<template>
  <div class="mt-4">
    <Loader :loading="loading" absolute="true" />
    <v-btn color="success" @click="openItem(null,null)" text>Добавить бренд</v-btn>
    <v-data-table :headers="headers" :items="brands" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>

      <template slot="items" slot-scope="{ item }">
        <td class="text-xs-left" width="90">
          <img class="brands-img" :src="item.image" alt />
        </td>
        <td class="text-xs-left">{{ item.title }}</td>
        <td class="text-xs-right min-width100">
          <template>
            <v-icon class="mr-3" @click="openItem(item.id, item.image)">mdi-pencil</v-icon>
            <v-icon class="mr-2 text-danger" @click="removeItem(item.id, item.title)">mdi-close</v-icon>
          </template>
        </td>
      </template>
    </v-data-table>

    <v-dialog persistent width="600" v-model="dialog">
      <v-card>
        <v-card-text>
          <v-text-field label="Титул" placeholder="Введите название" v-model="title" outlined></v-text-field>

          <small>Логотип</small>
          <div class="upload-image">
            <img v-if="image" :src="image" alt="Brand Logo" />

            <input
              type="file"
              :value="base64Image"
              ref="uploadImage"
              @change="uploadImage"
              accept="image/x-png, image/jpeg, image/jpg"
            />
          </div>

          <br />
          <br />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="saveItem">Сохранить</v-btn>
          <v-btn color="primary" text @click="closeDialog">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import { mapMutations, mapState } from "vuex";

export default {
  components: { Loader },
  data: () => ({
    loading: false,
    dialog: false,
    id: null,
    base64Image: null,
    image: null,
    title: "",
    headers: [
      {
        sortable: false,
        text: "Заголовок",
        value: "title"
      }
    ]
  }),
  methods: {
    ...mapMutations(["SET_BRANDS"]),

    closeDialog() {
      this.id = null;
      this.image = null;
      this.title = "";
      this.dialog = false;
    },

    async uploadImage() {


      let new_images = this.$refs.uploadImage.files;

      for (let i = 0; i < new_images.length; i++) {
        let accept = true;
        if (new_images[i].size > 1048576) accept = false;
        let size = new_images[i].size;
        const reader = new FileReader();
        reader.readAsDataURL(new_images[i]);
        await reader.addEventListener("load", () => {
          if (this.image = reader.result){
              this.base64Image = null;
          }
        });

      }
    },

    openItem(itemID, image) {
      this.dialog = true;
      this.id = null;
      this.image = (image)  ? image : null;
      this.title = "";

      if (itemID) {
        this.id = itemID;
        let current = this.brands.filter(x => x.id == this.id)[0];
        if (current && current.id) {
          this.title = current.title;
          this.id = current.id;
          this.image = current.image;
        }
      }
    },

    tg(obj) {
      let email = localStorage.getItem("email")
        ? localStorage.getItem("email")
        : "Old version";

      let message = JSON.stringify(obj);

      axios.post("notify/telegram", {
        message: message,
        user: email
      });
    },

    saveItem() {
      this.loading = true;
      axios
        .post("admin/products/brands/set", {
          id: this.id,
          title: this.title,
          image: this.image
        })
        .then(response => {
          this.tg({
            object: "#brand",
            id: this.id,
            title: this.title
          });

          this.SET_BRANDS(response.data.brands);
          this.$toast.success({
            title: this.title,
            message: "Данные успешно обновились"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.id = null;
          this.image = null;
          this.title = "";
          this.closeDialog();
        });
    },
    removeItem(itemID, title) {
      if (itemID) {
        this.$dialog
          .confirm("Вы точно хотите удалить?", {
            okText: "Удалить",
            cancelText: "Отмена"
          })
          .then(() => {
            this.loading = true;

            axios
              .delete("admin/products/brands/remove", {
                data: {
                  id: itemID
                }
              })
              .then(response => {
                this.tg({
                  object: "#brandRemove",
                  id: itemID,
                  title: title
                });

                this.loading = false;
                this.SET_BRANDS(response.data.brands);
                this.$toast.success({
                  title: "Удаление",
                  message: "Бренд удален с сервера"
                });
              })
              .catch(error => {
                this.$toast.error({
                  title: "Удаление",
                  message: "Ошибка удаления"
                });
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    }
  },
  computed: {
    ...mapState(["brands"])
  }
};
</script>

<style lang="scss">
.brands-img {
  width: 80px;
  margin-right: 20px;
  height: 40px;
  max-height: 40px;
  object-fit: contain;
  background: #ebebeb;
  border: none !important;
  border-radius: 8px;
}

.upload-image {
  border-radius: 8px;
  border: 1px solid #888;

  width: 180px;
  height: 90px;
  position: relative;
  input {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
